import { Migration } from '@mikro-orm/migrations';

export class Migration20250903000000_CreateNewsfeedTable extends Migration {
  async up(): Promise<void> {
    this.addSql(`
      create table "newsfeed" (
        "id" serial primary key,
        "user_id" integer not null,
        "title" varchar(255) not null,
        "subject" varchar(255) not null,
        "description" text not null,
        "created_at" timestamptz(0) not null,
        "updated_at" timestamptz(0) not null,
        "deleted_at" timestamptz(0) null,
        constraint "newsfeed_user_foreign" foreign key ("user_id") references "user" ("id") on delete cascade
      );
    `);
  }

  async down(): Promise<void> {
    this.addSql('drop table if exists "newsfeed" cascade;');
  }
}
